<template>
  <div>
    <v-checkbox
      :input-value="allSelected"
      :indeterminate="someSelected"
      @change="toggleAll"
      label="全選"
      dense
      hide-details
      class="mt-0 mb-2"
    ></v-checkbox>
    <div v-if="!value.length" class="red--text text-caption mb-2">請至少勾選一項權限</div>
    <v-row
      v-for="permission in availablePermissions"
      :key="permission.code_name"
      dense
      align="center"
      class="mb-1"
    >
      <v-col cols="auto">
        <v-checkbox
          :input-value="value"
          @change="handleChange"
          :value="permission.code_name"
          :label="permissionLabel(permission)"
          dense
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="auto">
        <v-btn
          text
          x-small
          color="teal"
          @click="$emit('open-page', permission.code_name)"
        >
          <v-icon x-small left>mdi-open-in-new</v-icon>
          開啟分頁
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { PERMISSION_MENU_NAMES } from '@/constants/permissions'

/**
 * AccountPermissionSelector - 可重用的權限選擇器組件
 *
 * 用途：
 * 1. 新增帳號時選擇權限
 * 2. 編輯帳號權限
 *
 * Props:
 * - value: 已選擇的權限代碼陣列（v-model）
 * - availablePermissions: 可用的權限列表
 *
 * Events:
 * - input: 選擇變更時觸發（v-model）
 * - open-page: 點擊「開啟分頁」時觸發
 */
export default {
  name: 'AccountPermissionSelector',
  props: {
    // v-model
    value: {
      type: Array,
      default: () => []
    },
    // 可用權限列表
    availablePermissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    allSelected() {
      return this.availablePermissions.length > 0
        && this.availablePermissions.every(p => this.value.includes(p.code_name))
    },
    someSelected() {
      return !this.allSelected
        && this.availablePermissions.some(p => this.value.includes(p.code_name))
    }
  },
  methods: {
    handleChange(selectedPermissions) {
      this.$emit('input', selectedPermissions)
    },
    permissionLabel(permission) {
      return PERMISSION_MENU_NAMES[permission.code_name] || permission.name
    },
    toggleAll(checked) {
      this.$emit('input', checked ? this.availablePermissions.map(p => p.code_name) : [])
    }
  }
}
</script>

<style scoped>
/* 可根據需要添加樣式 */
</style>
